import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Header from "../headers/private-header/Header";
import SideBar from "../side-bar/SideBar";

interface IProps {
  readonly header?: boolean;
}

const PrivateLayout: React.FC<IProps> = ({ header = true }) => {
  return (
    <Fragment>
      {header && (
        <Fragment>
          <Header />
          <SideBar />
        </Fragment>
      )}
      <div className="page-content">
        <Outlet />
      </div>
    </Fragment>
  );
};

export default PrivateLayout;